import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useSubscription from "../../../../customHooks/subscriptionProvider";
import { setShowInfo } from "../../../AxiosRtk/successMessage";
// import Facebook from '../../../../assets/images/icon-facebook.svg';

const Activities = ({ getLangTranslation }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { kidList, kidDevicesList, selectedKidId, selectedDeviceData } = useSelector(
    ({ dashboard }) => dashboard
  );

  const isKidListEmpty = kidList?.length === 0 ? true : false;
  const { checkSubsciption } = useSubscription();

  function handleSetRuleToMove() {
    if (isKidListEmpty) {
      return;
    }

    if (!checkSubsciption()) {
      return;
    }

    if (!selectedDeviceData) {
      dispatch(
        setShowInfo({
          showInfo: true,
          title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
          defaultTitle: "Please select device",
        })
      );
      return;
    }

    history.push("/set-rules");
  }

  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  const isDevicesAvailable = kidList && selectedKidId
    ? kidList.find(kid => kid?.ID === selectedKidId)?.KidsDevices?.[0]?.Name
    : null;


  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    // Disable the button if no device is available
    if (!isDevicesAvailable) {
      setIsButtonDisabled(true);
    } else {
      setIsButtonDisabled(false);
    }
  }, [isDevicesAvailable]); // Re-evaluate whenever isDevicesAvailable changes

  const handleScreenshotClick = (event) => {
    if (!selectedDeviceData) {
      dispatch(
        setShowInfo({
          showInfo: true,
          title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
          defaultTitle: "Please select device",
        })
      );
      return; 
    }
    if (!isButtonDisabled) {
      history.push({
        pathname: "/screenshots",
        state: { previousPage: "ACTIVITY" },
      })
    }
  };
  const handleGalleryClick = (event) => {
    if (!selectedDeviceData) {
      dispatch(
        setShowInfo({
          showInfo: true,
          title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
          defaultTitle: "Please select device",
        })
      );
      return; 
    }
    if (!isButtonDisabled) {
      history.push({
        pathname: "/gallery",
        state: { previousPage: "ACTIVITY" },
      })
    }
  };
  const handleYoutubeClick = (event) => {
    if (!selectedDeviceData) {
      dispatch(
        setShowInfo({
          showInfo: true,
          title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
          defaultTitle: "Please select device",
        })
      );
      return; 
    }
    if (!isButtonDisabled) {
      history.push({
        pathname: "/youtube-summary",
        state: { previousPage: "ACTIVITY" },
      })
    }
  };
  const handleNudityClick = (event) => {
    if (!selectedDeviceData) {
      dispatch(
        setShowInfo({
          showInfo: true,
          title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
          defaultTitle: "Please select device",
        })
      );
      return; 
    }
    if (!isButtonDisabled) {
      history.push({
        pathname: "/nudity",
        state: { previousPage: "ACTIVITY" },
      })
    }
  };
  const handleKeystrockClick = (event) => {
    if (!selectedDeviceData) {
      dispatch(
        setShowInfo({
          showInfo: true,
          title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
          defaultTitle: "Please select device",
        })
      );
      return; 
    }
    if (!isButtonDisabled) {
      history.push({
        pathname: "/keystrokes",
        state: { previousPage: "ACTIVITY" },
      })
    }
  };

  const handleCallSmsClick = (event) => {
    if (!selectedDeviceData) {
      dispatch(
        setShowInfo({
          showInfo: true,
          title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
          defaultTitle: "Please select device",
        })
      );
      return; 
    }
    if (!isButtonDisabled) {
      history.push({
        pathname: "/call-sms",
        state: { previousPage: "ACTIVITY" },
      })
    }
  };

  return (
    <div className="col-md-6 mb-6">
      <div className="card h-100">
        <div className="card-header">
          <h5
            className={`card-title mb-0 ${isKidListEmpty ? "text-gray" : ""}`}
          >
            {getLangTranslation("ACTIVITIES", "Activities")}
          </h5>
        </div>
        <div className="card-body">
          <div className="list-wrap d-activities">
            <div
              className="list-item d-flex align-items-center justify-content-between c-pointer d-activities-inner p-1 rounded-2"
              onClick={handleScreenshotClick}
            >
              <div className="d-flex align-items-center gap-2">
                <span className="icon-wrap">
                  <i
                    className={`icon-camera ${isKidListEmpty ? "text-gray" : ""
                      }`}
                  ></i>
                </span>
                <h6 className={`my-0 ${isKidListEmpty ? "text-gray" : ""}`}>
                  {getLangTranslation(
                    "CHILD_DETAIL_APP_SCREENSHOT",
                    "Screenshots"
                  )}
                </h6>
              </div>
              <i
                className={`fa ${lang?.isRTL === 1 ? "fa-angle-left" : "fa-angle-right"
                  }`}
              />
            </div>
            <hr className="my-5" />
            <div
              className="list-item d-flex align-items-center justify-content-between c-pointer d-activities-inner p-1 rounded-2"
              onClick={handleGalleryClick}
            >
              <div className="d-flex align-items-center gap-2">
                <span className="icon-wrap me-2">
                  <i
                    className={`icon-placeholder ${isKidListEmpty ? "text-gray" : ""
                      }`}
                  ></i>
                </span>
                <h6 className={`my-0 ${isKidListEmpty ? "text-gray" : ""}`}>
                  {getLangTranslation(
                    "CHILD_TASK_DETAILS_EVIDENCE_GALLERY",
                    "Gallery"
                  )}
                </h6>
              </div>
              <i
                className={`fa ${lang?.isRTL === 1 ? "fa-angle-left" : "fa-angle-right"
                  }`}
              ></i>
            </div>
            <hr className="my-5" />
            <div
              className="list-item d-flex align-items-center justify-content-between c-pointer d-activities-inner p-1 rounded-2"
              onClick={handleYoutubeClick}
            >
              <div className="d-flex align-items-center gap-2">
                <span className="icon-wrap me-2">
                  <i
                    className={`icon-video ${isKidListEmpty ? "text-gray" : ""
                      }`}
                  ></i>
                </span>
                <h6 className={`my-0 ${isKidListEmpty ? "text-gray" : ""}`}>
                  {getLangTranslation("CHILD_DETAIL_YOUTUBE", "YouTuve")}
                </h6>
              </div>
              <i
                className={`fa ${lang?.isRTL === 1 ? "fa-angle-left" : "fa-angle-right"
                  }`}
              />
            </div>
            <hr className="my-5" />
            <div
              className="list-item d-flex align-items-center justify-content-between c-pointer d-activities-inner p-1 rounded-2"
              onClick={handleNudityClick}
            >
              <div className="d-flex align-items-center gap-2">
                <span className="icon-wrap me-2">
                  <i
                    className={`icon-globe-shield ${isKidListEmpty ? "text-gray" : ""
                      }`}
                  ></i>
                </span>
                <h6 className={`my-0 ${isKidListEmpty ? "text-gray" : ""}`}>
                  {getLangTranslation("CHILD_DETAIL_NUDITY", "Nudity & Image Categorization")}
                </h6>
              </div>
              <i
                className={`fa ${lang?.isRTL === 1 ? "fa-angle-left" : "fa-angle-right"
                  }`}
              />
            </div>
            <hr className="my-5" />
            <div
              className="list-item d-flex align-items-center justify-content-between c-pointer d-activities-inner p-1 rounded-2"
              onClick={handleKeystrockClick}
            >
              <div className="d-flex align-items-center gap-2">
                <span className="icon-wrap me-2">
                  <i
                    className={`icon-key ${isKidListEmpty ? "text-gray" : ""}`}
                  ></i>
                </span>
                <h6 className={`my-0 ${isKidListEmpty ? "text-gray" : ""}`}>
                  {getLangTranslation("CHILD_DETAIL_KEYSTROKE", "Keystrokes")}
                </h6>
              </div>
              <i
                className={`fa ${lang?.isRTL === 1 ? "fa-angle-left" : "fa-angle-right"
                  }`}
              />
            </div>
            <hr className="my-5" />
            <div
              className="list-item d-flex align-items-center justify-content-between c-pointer d-activities-inner p-1 rounded-2"
              onClick={handleCallSmsClick}
            >
              <div className="d-flex align-items-center gap-2">
                <span className="icon-wrap me-2">
                  <i
                    className={`icon-phone-call ${isKidListEmpty ? "text-gray" : ""
                      }`}
                  ></i>
                </span>
                <h6 className={`my-0 ${isKidListEmpty ? "text-gray" : ""}`}>
                  {getLangTranslation(
                    "CHILD_DETAIL_CALL_AND_SMS",
                    "Calls & SMS"
                  )}
                </h6>
              </div>
              <i
                className={`fa ${lang?.isRTL === 1 ? "fa-angle-left" : "fa-angle-right"
                  }`}
              />
            </div>
            <hr className="my-5" />
            <div className="d-grid" onClick={() => handleSetRuleToMove()}>
              <button className="btn btn-primary text-uppercase" disabled={isButtonDisabled}>
                {getLangTranslation(
                  "CHILD_DETAIL_BUTTON_SET_RULE",
                  "SET RULES"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Activities;
